export const SET_ERROR_PAGE = "SET_ERROR_PAGE";
export const CLEAR_ERROR_PAGE = "CLEAR_ERROR_PAGE";
export const SET_AS_OF_DATE = "SET_AS_OF_DATE";
export const ROUTE_TO_ERROR_PAGE = "ROUTE_TO_ERROR_PAGE";
export const GET_DATACENTER_LIST = "GET_DATACENTER_LIST";
export const GET_NOTIFICATION_DATA = "GET_NOTIFICATION_DATA";
